import { useT } from "@/i18n/LanguageContext";

/** Four-virtues emblem closing every Academy lesson and phase. Decorative only:
 *  softly lit from within (static radial glow, no animation), never clickable. */
const SEAL_URL = "https://customer-assets-jt897jd0.emergentagent.net/job_virtue-guide-demo/artifacts/u90f95mc_IMG_6938.jpeg";

export function LessonVirtueSeal() {
  const { t } = useT();
  return (
    <div data-testid="lesson-virtue-seal"
      className="mt-20 mb-14 flex flex-col items-center select-none pointer-events-none">
      <div className="relative flex items-center justify-center">
        <div aria-hidden className="absolute w-[320px] h-[320px] md:w-[500px] md:h-[500px] rounded-full"
          style={{ background: "radial-gradient(circle, rgba(212,175,55,0.14) 0%, rgba(212,175,55,0.05) 45%, transparent 72%)" }} />
        <img src={SEAL_URL} alt="" loading="lazy" draggable="false"
          className="relative w-[250px] md:w-[400px] max-w-full h-auto"
          style={{ opacity: 0.9, mixBlendMode: "screen", filter: "drop-shadow(0 0 22px rgba(212,175,55,0.18))" }} />
      </div>
      <p className="mt-5 text-[11px] tracking-[0.28em] uppercase text-bone/45 text-center px-6">
        {t("academy.lesson.virtueSeal")}
      </p>
    </div>
  );
}
